module.exports = __webpack_public_path__ + "static/media/img_fenlei05.6f4f6c6d.png";